import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import SelectPicker from '../../components/SelectPicker';
import FormInput from '../../components/FormInput';
import {ModelListSelect} from 'vue-search-select';

export default {
    name: "trips-create",
    components: {Datepicker, SelectPicker, FormInput, ModelListSelect},
    data() {
        return {
            options: {
                format: 'Y-MM-DD H:mm',
                useCurrent: false,
                showClear: false,
                showClose: false,
                inline: false,
                icons: {
                    time: 'mdi mdi-timer',
                    date: 'mdi mdi-timetable',
                    up: 'mdi mdi-chevron-up',
                    down: 'mdi mdi-chevron-down',
                    previous: 'mdi mdi-chevron-left',
                    next: 'mdi mdi-chevron-right',
                    today: 'mdi mdi-calendar-today',
                    clear: 'mdi mdi-delete',
                    close: 'mdi mdi-close-box'
                }
            },
            routes_list: [],
            stations_list: [],
            buses_list: [],
            drivers_list: [],
            tariff_list: [],
            route_id: '',
            bus_id: '',
            // platform: '',
            driver_id: '',
            driver_id2: '',
            driver_id3: '',
            tariff_id: '',
            trip_id: '',
            payment_calculation_type: 1,
            time: this.$moment().format("YYYY-MM-DD H:mm"),
            calculation_types: [],
            trip_prices: [],
            price_for_save: [],

            is_loading_item: false,
            loading_item_count:0,
        }
    },
    methods: {
        loadTrip() {
            let id = this.$route.params.id;
            let params = {};
            if (id > 0) {
                params.id = id;
                this.$api.get('trips.show', params).then(({data}) => {
                    this.route_id = data.route_id;
                    this.bus_id = data.bus_id;
                    this.platform = data.platform;
                    this.driver_id = data.driver_id;
                    this.driver_id2 = data.driver_id2;
                    this.driver_id3 = data.driver_id3;
                    this.tariff_id = data.tariff_id;
                    this.trip_id = data.id;
                    this.payment_calculation_type = parseInt(data.payment_calculation_type);
                    this.time = this.$moment(data.time).format("YYYY-MM-DD H:mm");
                    this.loading_item_count++;
                });
            }
        },
        loadCalculationTypes() {
            this.$api.get('schedule-trips.calculation')
                .then(res => {
                    this.calculation_types = res.data;
                    this.loading_item_count++;
                });
        },
        loadRoutes() {
            this.$api.get('routes.all').then(({data}) => {
                this.routes_list = data;
                this.handleRouteChange();
                this.loading_item_count++;
            });
        },
        loadBuses() {
            this.$api.get('trips.buses').then(({data}) => {
                this.buses_list = data;
                this.loading_item_count++;
            });
        },
        loadTariffs() {
            this.$api.get('trips.tariffs').then(({data}) => {
                this.tariff_list = data;
                this.loading_item_count++;
            });
        },
        loadDrivers() {
            this.$api.get('trips.drivers').then(({data}) => {
                this.drivers_list = data;
                this.loading_item_count++;
            });
        },
        fullNameOfRoute(route) {
            return route.name + ' (' + route.number + ')';
        },
        fullNameOfBus(bus) {
            return bus.bus_model + ' [' + bus.bus_number + '] - ' + bus.transporter;
        },
        save() {
            this.setTripPrice();
            let postData = {};
            postData.route_id = this.route_id;
            postData.bus_id = this.bus_id;
            postData.platform = this.platform;
            postData.driver_id = this.driver_id;
            postData.driver_id2 = this.driver_id2;
            postData.driver_id3 = this.driver_id3;
            postData.time = this.formattedDate;
            postData.tariff_id = this.tariff_id;
            postData.trip_id = this.trip_id;
            postData.prices = this.price_for_save;
            postData.price = this.trip_prices[0][this.trip_prices[0].length - 1];

            this.$api.post('trips.store', postData)
                .then(res => {
                    this.$notify({
                        type: 'success',
                        group: 'foo',
                        title: this.i18n('Successfully!!!' ),
                        text: this.i18n('Trip has been created successfully')
                    });
                    this.$store.commit('tripDate', this.formattedDate);
                    this.$router.replace({name: "trips.index"});
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        let text = '';
                        Object.keys(err.response.data.errors).forEach(field => {
                            text += err.response.data.errors[field].join(' ') + "<br/>";
                        });
                        this.$notify({
                            type: 'error',
                            group: 'foo',
                            title: err.response.data.message,
                            text: text
                        });
                    }
                });
        },
        calculatePrices() {
            let tariff = this.tariff_list.find(item => item.id === this.tariff_id);
            let t_price = tariff ? parseInt(tariff.price_per_km) : 0;
            let per_price = 0;
            for (let i = 0; i < this.stations_list.length; i++) {
                per_price = 0;
                if (i < this.stations_list.length - 1) {
                    this.trip_prices[i] = [];
                    for (let j = 0; j < this.stations_list.length; j++) {
                        if (j > i) {
                            per_price += parseInt(this.stations_list[j].distance) * t_price;
                            this.trip_prices[i][j] = per_price;
                        }
                    }
                }
            }
            this.$forceUpdate();
        },
        setTripPrice() {
            this.price_for_save = [];
            for (let i = 0; i < this.stations_list.length; i++) {
                if (i < this.stations_list.length - 1) {
                    for (let j = 0; j < this.stations_list.length; j++) {
                        if (j > i) {
                            if (this.trip_prices[i][j] > 0) {
                                this.price_for_save.push({
                                    from: this.stations_list[i].station_id,
                                    to: this.stations_list[j].station_id,
                                    price: parseInt(this.trip_prices[i][j])
                                });
                            }
                        }
                    }
                }
            }
        },
        handleRouteChange() {
            let route = this.routes_list.find(item => item.id === this.route_id);
            this.stations_list = route ? route.routes_stations : [];
            this.calculatePrices();
        }
    },
    computed: {
        formattedDate: function () {
            let date = new Date(this.time);
            return date.getFullYear() + '-' +
                (date.getMonth() + 1) + '-' +
                date.getDate() + ' ' + date.getHours() +
                ':' + date.getMinutes();
        }
        /*listForSecondDriver() {
            let drivers = this.drivers_list;
            let index = drivers.indexOf(this.selected_driver);
            if (index !== -1) drivers.splice(index, 1);
            return drivers;
        },
        listForThirdDriver() {
            let drivers = this.drivers_list;

            let index = drivers.indexOf(this.selected_driver);
            if (index !== -1) drivers.splice(index, 1);

            let index2 = drivers.indexOf(this.selected_driver2);
            if (index2 !== -1) drivers.splice(index2, 1);
            return drivers;
        },*/
    },
    watch: {
        route_id: function () {
            this.handleRouteChange();
        },
        tariff_id: function () {
            this.calculatePrices();
        },
        loading_item_count (value){
            if(value == 6){
                this.is_loading_item = false
            }
        }
    },
    mounted() {
    },
    created() {
        this.time = this.$store.state.trips.date || this.$moment().format("YYYY-MM-DD");
        this.is_loading_item = true
        this.loadTrip();
        this.loadRoutes();
        this.loadBuses();
        this.loadDrivers();
        this.loadTariffs();
        this.loadCalculationTypes();
    }
}
